/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react';

import Modal from 'react-modal';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '@client/logic/cropImage';
import { debounce } from 'lodash';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { AnyFn } from '../helpers/types';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onSave: () => void;
  aspectRatio: number | undefined;
  value?: string;
  onChange: (image: string) => void;
  disabled?: boolean;
};
export default function CropModal({
  isOpen,
  onCancel,
  onSave,
  aspectRatio,
  value,
  onChange,
  disabled = false,
}: Props) {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Example Modal"
      style={{
        overlay: {
          zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: {
          paddingRight: '40px',
          paddingLeft: '40px',
          paddingBottom: '40px',
          backgroundColor: 'black',
          position: 'relative',
          width: '80vw',
          height: '60vh',
          borderRadius: '20px',
        },
      }}
    >
      <a
        onClick={onCancel}
        className="absolute right-6 text-3xl text-white hover:text-primary hover:cursor-pointer"
      >
        <Icon icon={faClose} />
      </a>
      <div className="text-2xl text-white text-center font-normal mb-4">
        Move the image to fit into highlighted area
      </div>
      <div
        className="relative"
        style={{
          width: '100%',
          height: 'calc(100% - 140px)',
          // background: 'white',
        }}
      >
        {value && aspectRatio && (
          <CropImage src={value} onChange={onChange} aspect={aspectRatio} />
        )}
      </div>
      <div className="w-full text-center">
        <button
          onClick={onSave}
          disabled={disabled}
          className="bg-primary text-white rounded-lg text-2xl mt-8 p-4 px-20"
        >
          Upload
        </button>
      </div>
    </Modal>
  );
}

function useEasyCrop({
  src,
  aspect = 1,
  onChange,
}: {
  onChange: AnyFn;
  aspect?: number;
  src?: any;
}): Cropper['props'] {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const onChangeHandlerDebounced = useCallback(
    debounce(async (croppedAreaPixels) => {
      const croppedImage = await getCroppedImg(
        src,
        croppedAreaPixels,
        rotation,
      );
      onChange(croppedImage);
    }, 200),
    [],
  );

  const onCropComplete = useCallback(
    async (_croppedArea, croppedAreaPixels) => {
      onChange(null);
      // NOTE: most likely doesn't support rotation after cropping
      onChangeHandlerDebounced(croppedAreaPixels);
    },
    [],
  );

  // @ts-ignore
  return {
    image: src,
    crop,
    rotation,
    onCropChange: setCrop,
    onCropComplete,
    onRotationChange: setRotation,
    aspect,
    zoomWithScroll: true,
    onZoomChange: setZoom,
    zoom,
  };
}

type CropImageProps = {
  src: string;
  aspect: number;
  onChange: (image: string) => void;
};
function CropImage({ src, aspect = 1, onChange }: CropImageProps) {
  const cropper = useEasyCrop({ src, aspect, onChange });

  return (
    <div>
      <Cropper {...cropper} />
    </div>
  );
}
